export default __webpack_public_path__ + "e48d67a029dc969004e2da7b91af2cc9.wasm";